import React from 'react';
import { outcomeBadgeTone } from '../../../utils/marketingApi';
import cm from '../CallManager.module.scss';

export default function RefollowActionBanner({ action, onEdit }) {
  if (!action) return null;
  const tone = action.outcome
    ? outcomeBadgeTone(action.outcome)
    : (action.status === 'cancelled' ? 'danger' : 'success');
  return (
    <div className={cm.actionBanner} data-tone={tone} role="status" aria-live="polite">
      <div className={cm.actionBannerMain}>
        <span className={cm.actionBannerIcon} aria-hidden>✓</span>
        <div className={cm.actionBannerText}>
          <span className={cm.actionBannerTitle}>{action.outcomeLabel} saved</span>
          <span className={cm.actionBannerMeta}>
            {action.memberName || 'Customer'} · {action.phone || '—'}
          </span>
        </div>
      </div>
      <button type="button" className={cm.actionBannerEditBtn} onClick={onEdit}>
        Edit status
      </button>
    </div>
  );
}
